import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { C_Ai_Assistant_Query_Status } from '../../../../graphql/generatedModel';
import { Guard } from '../../guard/guard.component';
import { AIAssistanRes } from '../service/aiAssistant.service';
import { AlertMessage } from './alertMessage.component';
import { ExpertMode } from './expertMode.component';
import { File } from './file.component';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

export const Response: FC<{ data: AIAssistanRes }> = ({ data }) => {
  const {
    status,
    reply: {
      content: { text, files, expert_mode },
    },
  } = data;
  const { t } = useTranslation('');

  return (
    <>
      {status === C_Ai_Assistant_Query_Status.AQS_SUCCESS && (
        <>
          <Box
            sx={{
              display: 'inline-block',
              marginBottom: '16px',
              padding: '8px 16px 16px',
              borderRadius: '10px',
              background: `rgba(244, 140, 7, 0.12)`,
            }}
          >
            <Typography
              sx={{
                width: 'auto',
                fontSize: 14,
                fontWeight: 600,
                color: 'rgba(244, 140, 7, 1)',
                marginBottom: '6px',
              }}
            >
              {t('aiAssistant.title')}
            </Typography>
            <Typography
              sx={{
                width: 'auto',
                whiteSpace: 'pre-wrap',
                '& > a': {
                  color: 'primary.main',
                  '&:hover': {
                    color: 'primary.dark',
                    textDecoration: 'underline !important',
                  },
                },
              }}
              variant='body2'
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
            />
          </Box>
          <Box>
            {files.map((file) => {
              return <File key={file!.path} file={file} />;
            })}
          </Box>
          <Guard module='layout' componentName='expertMode'>
            <Box sx={{ marginTop: '10px' }}>
              <ExpertMode data={expert_mode!} />
            </Box>
          </Guard>
        </>
      )}
      {status === C_Ai_Assistant_Query_Status.AQS_ERROR && (
        <AlertMessage type='error' message={t('aiAssistant.aiAssistantError')} />
      )}
    </>
  );
};
